export default __webpack_public_path__ + "static/media/SortingImg.2bff4341.jpg";